import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"logo-chrome"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M22.0034 12.002C22.0034 17.5248 17.5263 22.002 12.0034 22.002C6.48057 22.002 2.00342 17.5248 2.00342 12.002C2.00342 6.47911 6.48057 2.00195 12.0034 2.00195C17.5263 2.00195 22.0034 6.47911 22.0034 12.002Z"}},{"tag":"ellipse","attrs":{"id":"fill2","cx":12.0013,"cy":12.0007,"fill":"props.fillColor2","rx":4.00125,"ry":4.00075}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M13 7.99915L20.6673 7.99915M15.05 14.7133L11.1285 21.5055M4.20264 6.49633L8.125 13.2901M16.0025 12.0008C16.0025 14.2103 14.2111 16.0015 12.0013 16.0015C9.79142 16.0015 8 14.2103 8 12.0008C8 9.79122 9.79142 8.00002 12.0013 8.00002C14.2111 8.00002 16.0025 9.79122 16.0025 12.0008ZM22.0034 12.002C22.0034 17.5248 17.5263 22.002 12.0034 22.002C6.48057 22.002 2.00342 17.5248 2.00342 12.002C2.00342 6.4791 6.48057 2.00195 12.0034 2.00195C17.5263 2.00195 22.0034 6.4791 22.0034 12.002Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const LogoChrome = Vue.extend<IconProps>({
  name: 'LogoChromeIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'logo-chrome',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default LogoChrome;
